var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.366399 0.803411C0.0783877 1.09142 0.0783877 1.55838 0.366399 1.84639L4.26991 5.7499L0.366399 9.65341C0.0783877 9.94142 0.0783877 10.4084 0.366399 10.6964C0.654411 10.9844 1.12137 10.9844 1.40938 10.6964L5.83438 6.27139C6.12239 5.98338 6.12239 5.51642 5.83438 5.22841L1.40938 0.803411C1.12137 0.515399 0.654411 0.515399 0.366399 0.803411Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.df0ecdc96cf6b4666d551231d85ee6ed.svg";
export { ForwardRef as ReactComponent };